import styled from 'styled-components';
import { colors } from '../../const/color';

export const ErrorComponentWrapStyled = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const ErrorComponentStyled = styled.div`
  padding: 25px;
  text-align: center;
  width: 350px;
  background: ${colors.grayE7};

  h1 {
    font-size: 56px;
    line-height: 68px;
  }
`;
